import React from 'react'
import './style.scss'
import TestimonialItem from './TestimonialItem';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import MoveTrigger from "../../animation/MoveTrigger";
import { Pagination, SwiperOptions } from "swiper";
import { dsnCN } from "../../hooks/helper";


const TestimonialDetails = [
    {
        name: "Eldric",
        label: "Wanderer of the Quiet Realms",
        src: "assets/img/avatar/eldric.jpg",
        description: `"I have walked beneath forgotten skies and mapped the silence between stars. I dwell where the river turns back on itself."`
    },
    {
        name: "Seraphine",
        label: "Keeper of the Windless Chimes",
        src: "assets/img/avatar/seraphine.jpg",
        description: `"I guard the path where bells ring without wind. If you hear them, you are already close."`
    },
    {
        name: "Elandor",
        label: "Last Son of Stonewatch",
        src: "assets/img/avatar/elandor.jpg",
        description: `"I was forged in mountain shadow. I trust stone, silence, and the strength of what endures."`
    },
    {
        name: "Lyra",
        label: "Daughter of the Sapphire Sky",
        src: "assets/img/avatar/lyra.jpg",
        description: `"I speak softly so the stars may answer. Light follows where I choose to walk."`
    }

]


function Testimonial({ className, title, ...restProps }: SwiperOptions) {
    return (

        <section className={dsnCN('dsn-testimonial background-section testimonial-one', className)}>
            <div className="testimonial-inner ">
                <div className="title-box">
                    {title &&
                        <MoveTrigger from={{ y: 0, opacity: 0 }} to={{ y: -60, opacity: 1 }} mobile={false}>
                            {(ref) => <h2 className='title-section p-relative z-index-1' ref={ref}>
                                {title}
                            </h2>}
                        </MoveTrigger>
                    }

                </div>
                <div className='content-box'>
                    <Swiper
                        modules={[Pagination]}
                        pagination={{ clickable: true, el: '.swiper-pagination' }}
                        slidesPerView={1}
                        {...restProps}
                    >
                        {TestimonialDetails.map(
                            (item, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <TestimonialItem
                                            src={item.src} authorName={item.name} label={item.label}
                                            description={item.description} />
                                    </SwiperSlide>

                                );
                            }
                        )}

                        <div className="swiper-pagination" />

                    </Swiper>
                </div>

            </div>
        </section>

    )
}


export default Testimonial;